import { useCallback, useMemo } from "react";
import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "../index";
import { useSelector } from "react-redux";
import { getFlightDetailsSegments } from "../../../store/flightDetails/selectors";
import getTechnicalStops from "../../get-technical-stops";

const utils = createTrackingUtils({
  name: "flights_funnel_web_condensed_itinerary",
  defaultStage: 1,
  stages: {
    main: 1,
    direct: 2,
    meta: 3,
    layover: 4,
    nolayover: 5,
    techStop: 6,
    solo: 7,
    nonSolo: 8
  },
  goals: {}
});

export default function useFlightsFunnelWebCondensedItinerary() {
  const segments = useSelector(getFlightDetailsSegments);
  const { isMobile, isPb, isDirect, isSolo } = useProfiler();

  const isTechStops = useMemo(
    () => !!segments?.some((segment) => !!getTechnicalStops.fromSegment(segment).length),
    [segments]
  );

  const isLayover = useMemo(() => segments?.some((segment) => segment.legs.length > 1), [segments]);

  const trackStages = useCallback(() => {
    utils.stages.main();
    if (isDirect()) utils.stages.direct();
    else utils.stages.meta();
    if (isLayover) utils.stages.layover();
    if (!isTechStops && !isLayover) utils.stages.nolayover();
    if (isTechStops) utils.stages.techStop();
    if (isSolo()) utils.stages.solo();
    else utils.stages.nonSolo();
  }, [isDirect, isSolo, isTechStops, isLayover]);

  const isVariant = useCallback(() => {
    if (!isMobile()) return false;
    if (isPb()) return false;
    trackStages();
    return !!utils.trackWithDefaultStage();
  }, [isMobile, trackStages, isPb]);

  return isVariant;
}
